import { ConnectedOverlayPositionChange, ConnectedPosition } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { createCloseOnScrollOverlayStrategy } from '../../utils/overlay-scroll-strategy.util';
import {
  CoreUIContextMenuAppearance,
  CoreUIContextMenuItem,
  CoreUIContextMenuSize,
  CoreUIContextMenuVariant,
} from '../core-ui-context-menu/core-ui-context-menu.component';

@Component({
  selector: 'core-ui-action-menu',
  templateUrl: './core-ui-action-menu.component.html',
  styleUrls: ['./core-ui-action-menu.component.scss'],
  standalone: false,
})
export class CoreUIActionMenuComponent {
  @ViewChild('trigger') private trigger?: ElementRef<HTMLButtonElement>;

  @Input() items: readonly CoreUIContextMenuItem[] = [];
  @Input() ariaLabel = 'Acciones';
  @Input() triggerAriaLabel = 'Mostrar acciones';
  @Input() appearance: CoreUIContextMenuAppearance = 'light';
  @Input() size: CoreUIContextMenuSize = 'md';
  @Input() variant: CoreUIContextMenuVariant = 'default';
  @Input() viewportMargin = 8;
  @Input() disabled = false;

  @Output() actionSelected = new EventEmitter<string>();

  isOpen = false;
  menuPosition: 'above' | 'below' = 'below';
  readonly push = true;
  readonly scrollStrategy = createCloseOnScrollOverlayStrategy(inject(DOCUMENT));
  readonly positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
      offsetY: 6,
    },
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
      offsetY: -6,
    },
  ];

  get isTriggerDisabled(): boolean {
    return this.disabled || !this.items.some((item) => !item.disabled);
  }

  toggle(): void {
    if (this.isTriggerDisabled) return;

    if (this.isOpen) {
      this.close(true);
      return;
    }

    this.menuPosition = 'below';
    this.isOpen = true;
  }

  selectAction(actionId: string): void {
    this.close(true);
    this.actionSelected.emit(actionId);
  }

  close(restoreFocus = false): void {
    this.isOpen = false;

    if (restoreFocus) {
      queueMicrotask(() => this.trigger?.nativeElement.focus());
    }
  }

  onPositionChange(change: ConnectedOverlayPositionChange): void {
    this.menuPosition = change.connectionPair.overlayY === 'bottom' ? 'above' : 'below';
  }
}
